export default __webpack_public_path__ + "static/media/welcomeLandingbg-student.caade639.png";